import { useContext, useEffect, useRef, useState } from 'react'
import { reaction } from 'mobx'
import { AxiosContext } from '../context/request.context'
import usersStore from '../store/users'
const qs = require('qs')

const query = qs.stringify(
  {
    sort: {
      step: 'asc'
    },
    populate: {
      statuses: {
        sort: ['sort:asc'],
        populate: {
          m_roles: true
        }
      },
      suggests: true,
      m_roles: true
    },
    //TODO STAGE HIDE FILTER
    filters: {
      isHideStage: {
        $eq: false
      }
    }
  },
  {
    encodeValuesOnly: true // prettify URL
  }
)

/**
 * Статус без привязки к m_roles виден всем (кроме случая watchOnlyRelatedStatuses у роли пользователя).
 * Статус с m_roles виден только если у пользователя есть хотя бы одна из этих ролей.
 * Если у пользователя есть роль с watchOnlyRelatedStatuses === true — статусы без m_roles не показываем.
 * При godmod — все статусы этапа.
 */
const filterStatusesByUserRoles = (statuses, userRoleIds, hasGodmod, userRoles = []) => {
  if (!Array.isArray(statuses)) {
    return []
  }
  if (hasGodmod) {
    return statuses
  }
  const ids = Array.isArray(userRoleIds) ? userRoleIds.filter(Boolean) : []
  const hideUnboundStatuses = userRoles.some(r => r.watchOnlyRelatedStatuses === true)

  return statuses.filter(status => {
    const statusRoles = status.m_roles
    if (!Array.isArray(statusRoles) || statusRoles.length === 0) {
      if (hideUnboundStatuses) {
        return false
      }
      return true
    }
    if (!ids.length) {
      return false
    }
    const statusRoleIds = statusRoles.map(r => r.id)
    return statusRoleIds.some(rid => ids.includes(rid))
  })
}

const normalizeStagesFromApi = data =>
  (data || [])
    .filter(stage => !stage.isHideStage)
    .map(stage => ({
      ...stage,
      statuses: Array.isArray(stage.statuses) ? stage.statuses.filter(status => !status.deactivated) : []
    }))

const applyRoleFilterToStages = rawStages => {
  const roles = usersStore.currentUser.role || usersStore.currentUser.m_roles || []
  const userRoleIds = roles.map(r => r.id)
  const hasGodmod = !!usersStore.isGodMod()

  return rawStages.map(stage => ({
    ...stage,
    statuses: filterStatusesByUserRoles(stage.statuses, userRoleIds, hasGodmod, roles)
  }))
}

function useStages() {
  const { authRequest } = useContext(AxiosContext)
  const [stages, setStages] = useState([])
  const rawRef = useRef(null)

  useEffect(() => {
    const dispose = reaction(
      () => {
        const roles = usersStore.currentUser.role || usersStore.currentUser.m_roles || []
        const ids = roles.map(r => r.id).join(',')
        const god = roles.some(r => r.godmod) ? '1' : '0'
        const watch = roles.map(r => (r.watchOnlyRelatedStatuses === true ? '1' : '0')).join('')
        return `${ids}|${god}|${watch}`
      },
      () => {
        if (rawRef.current) {
          setStages(applyRoleFilterToStages(rawRef.current))
        }
      }
    )
    return () => dispose()
  }, [])

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const { data } = await authRequest({
        url: 'stages?' + query
      })
      if (cancelled) {
        return
      }
      const normalized = normalizeStagesFromApi(data)
      rawRef.current = normalized
      setStages(applyRoleFilterToStages(normalized))
    })()
    return () => {
      cancelled = true
    }
  }, [authRequest])

  return {
    stages
  }
}

export default useStages
